export enum FileExtension {
    Pdf = 'pdf',
    Docx = 'docx',
    Doc = 'doc',
    Jpg = 'jpg',
    Jpeg = 'jpeg',
}
